function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.5H1.5M16.833 7L16.373 13.9C16.196 16.554 16.108 17.881 15.243 18.69C14.378 19.499 13.047 19.5 10.387 19.5H9.613C6.953 19.5 5.622 19.5 4.757 18.69C3.892 17.881 3.803 16.554 3.627 13.9L3.167 7M7.5 9.5L8 14.5M12.5 9.5L12 14.5",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5H4.61C5.01245 4.48972 5.40242 4.35822 5.72892 4.12271C6.05543 3.8872 6.30325 3.55864 6.44 3.18L6.474 3.077L6.571 2.786C6.654 2.537 6.696 2.413 6.751 2.307C6.85921 2.09939 7.01451 1.91999 7.20448 1.78316C7.39444 1.64633 7.6138 1.55586 7.845 1.519C7.962 1.5 8.093 1.5 8.355 1.5H11.645C11.907 1.5 12.038 1.5 12.155 1.519C12.3862 1.55586 12.6056 1.64633 12.7955 1.78316C12.9855 1.91999 13.1408 2.09939 13.249 2.307C13.304 2.413 13.346 2.537 13.429 2.786L13.526 3.077C13.6527 3.49827 13.9148 3.86601 14.2717 4.12326C14.6285 4.38051 15.0603 4.51293 15.5 4.5",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconPrimary);
export default __webpack_public_path__ + "static/media/delete_icon_primary.cd6004a25b721e4fd7b9b150574213da.svg";
export { ForwardRef as ReactComponent };